import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import styles from '../Pickups/PickupWizard.module.css'; // Import css modules stylesheet as styles
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const retailsStores = [
    {
        value: 'Meijer',
        label: '',
        img: 'images/Grocery/Meijer.svg'
    },
    {
        value: 'Target',
        label: '',
        img: 'images/Grocery/Target.png'
    },
    {
        value: 'Walmart',
        label: '',
        img: 'images/Grocery/Walmart.png'
    },
    {
        value: 'Family Dollar',
        label: '',
        img: 'images/Grocery/FamilyDollar.png'
    },
    {
        value: 'Gordon Foods',
        label: '',
        img: 'images/Grocery/GordonFoods.png'
    },
    {
        value: 'IGA',
        label: '',
        img: 'images/Grocery/IGA.png'
    },
    {
        value: 'Dollar Green',
        label: '',
        img: 'images/Grocery/DollarTree.png'
    },
    {
        value: 'Sams Club',
        label: '',
        img: 'images/Grocery/SamsClub.png'
    },
    {
        value: 'Costco',
        label: '',
        img: 'images/Grocery/Costco.png'
    },
];

export default function AddBrand(props) {
    const [open, setOpen] = React.useState(false);
    const [companyName, setCompanyName] = React.useState(props.companyName);
    const [brandName, setBrandName] = React.useState(props.brandName);
    const [isAccepted, setIsAccepted] = React.useState(true);

    const [storeAddress, setStoreAddress] = React.useState('');
    const [storeCity, setStoreCity] = React.useState('');
    const [storeState, setStoreState] = React.useState('');
    const [storeZip, setStoreZip] = React.useState('');

    const [selectedStores, setSelectedStores] = React.useState([]);
    const [otherStore, setOtherStore] = React.useState('');

    const [formErrors, setFormErrors] = React.useState({});

    const handleClose = (accepted) => {
        props.Close(accepted);
    };

    function toggleSelected(val) {
        if (val !== null) {
            //let selectedStoresCopy;
            //if (selectedStores.includes(val)) {
            //    // remove it
            //    selectedStoresCopy = [];
            //    for (let i = 0; i < selectedStores.length; i++) {
            //        if (selectedStores[i] !== val) {
            //            selectedStoresCopy.push(selectedStores[i]);
            //        }
            //    }
            //}
            //else {
            //    selectedStoresCopy = selectedStores.splice(0);
            //    selectedStoresCopy.push(val);
            //}

            //setSelectedStores(selectedStoresCopy);
            setSelectedStores(val);
            setOtherStore('');
        }
    }

    function handleIsAcceptedChanged(newValue) {
        if (newValue == null) {
            return; // don't allow Unclicked
        }
        setIsAccepted(newValue)
       
    }

    function validate() {
        let errors = {};
        let isValid = true;
        if (companyName.trim().length == 0 ) {
            isValid = false;
            errors.companyName = 'ie: Pepsi, La Croix, Founders';
        }

        if (selectedStores=='' && otherStore.trim() == '') {
            isValid = false;
            errors.store = '* You must select a store'
        }

        setFormErrors(errors);
        if (isValid) {
            let brand = {
                CompanyName: companyName,
                BrandName: brandName,
                IsAccepted: isAccepted,
                StoreName: selectedStores.length == 0 ? otherStore : selectedStores.trim(),
                StoreAddress: storeAddress,
                StoreCity: storeCity,
                StoreState: storeState,
                StoreZip: storeZip
            }
            props.Close(true, brand)
        }
        
    }

    return (

        <Dialog
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={true}
        >
            <DialogTitle id="alert-dialog-title">
                Add a Brand
            </DialogTitle>
            <DialogContent>
                <div style={{fontSize:'10pt'} }>
                    Help yourself and other recyclers tag where brands are Accepted/Not Accepted.
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <div style={{ display: 'flex' }}>
                                <img src='images/BreweryIcon.png' style={{ height: '35px', alignSelf: 'center', marginRight: '10px' }} />
                                <TextField error={formErrors.companyName !== undefined} style={{ alignSelf: 'flex-start' }} label="Brand/Brewery" onChange={(e) => setCompanyName(e.target.value)} value={companyName} variant="outlined" />

                            </div>
                            <div style={{ color: 'var(--sipzee-red)', height: '1rem' }}>{formErrors.companyName}</div>
                        </div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <div style={{ display: 'flex' }}>
                                <img src='images/FlavorIcon.png' style={{ height: '35px', alignSelf: 'center', marginRight: '10px' }} />
                                <TextField error={formErrors.brandName !== undefined} style={{ alignSelf: 'flex-start' }} label="Flavor" onChange={(e) => setBrandName(e.target.value)} value={brandName} variant="outlined" />
                            </div>
                            
                            <div style={{fontStyle:'italic', fontSize:'10pt'} }>(Optional) Specific flavor or type</div>
                            <div style={{ color: 'var(--sipzee-red)', height: '1rem' }}>{formErrors.brandName}</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <ToggleButtonGroup
                            
                            value={isAccepted}
                            exclusive
                            onChange={(e, newValue) => handleIsAcceptedChanged(newValue)}
                            aria-label="Platform"
                            style={{marginTop:'10px'} }
                        >
                            <ToggleButton color="sipzeeGreen" value={true}><CheckCircleIcon sx={{ color: isAccepted ? 'var(--sipzee-green)' : '', fontSize: 30 }}/> Is Accepted</ToggleButton>
                            <ToggleButton color="sipzeeRed" value={false}>Not Accepted <BlockIcon sx={{ color: isAccepted ? '' : 'var(--sipzee-red)' , fontSize: 30 }} /></ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>

                <div style={{ marginTop: '15px',marginBottom:'5px', display: 'flex', flexWrap: 'wrap' }}>
                    <div style={{ color: 'var(--sipzee-red)', height: '1rem' }}>{formErrors.store}</div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {retailsStores.map((retailStore, index) => (

                        <div key={retailStore.value} style={{ position: 'relative', display: 'flex', flexDirection: 'row', margin: '2px' }} onClick={(e) => toggleSelected(retailStore.value)}>
                            {/* {<StyledCheckbox style={{ alignSelf: 'center' }} />}*/}
                            <Paper elevation={8} className={styles.paperImageCard} style={{ height: '75px', width: '75px', display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', alignSelf: 'center' }}>
                                    <img src={retailStore.img} style={{ maxHeight: '60px', maxWidth: '60px' }} />
                                    <div style={{ alignSelf: 'center' }}>{retailStore.label}</div>
                                    {!selectedStores.includes(retailStore.value) ? null :
                                        <CheckCircleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} style={{ position: 'absolute', backgroundColor: 'none', top: '0px', left: '-5px' }} />
                                    }
                                </div>
                            </Paper>
                        </div>
                    ))}

                </div>
                <div style={{ marginTop: '15px' }}>
                    <TextField label="Other Store"

                        onChange={(e) => { setOtherStore(e.target.value); setSelectedStores([]) }}
                        value={otherStore}
                        variant="outlined"
                    />
                </div>
                {otherStore == '' ? null :
                    <div style={{ marginTop: '15px', display:'flex', justifyContent:'center', flexDirection:'column' }}>
                        <div>Store Address</div>
                        <div style={{ fontStyle: 'italic', fontSize: '10pt' }}>(Optional) Help others find this store</div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <TextField style={{ alignSelf: 'flex-start' }} label="Store Address" onChange={(e) => setStoreAddress(e.target.value)} value={storeAddress} variant="outlined" />
                        </div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <TextField style={{ alignSelf: 'flex-start' }} label="Store City" onChange={(e) => setStoreCity(e.target.value)} value={storeCity} variant="outlined" />
                        </div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <TextField style={{ alignSelf: 'flex-start' }} label="Store State" onChange={(e) => setStoreState(e.target.value)} value={storeState} variant="outlined" inputProps={{ maxLength: '2'}} />
                        </div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <TextField style={{ alignSelf: 'flex-start' }} label="Store Zip" onChange={(e) => setStoreZip(e.target.value)} value={storeZip} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: '5' }} />
                        </div>
                    </div>
                }
            </DialogContent>
            <DialogActions>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button variant='outlined' onClick={() => handleClose(false)}>Cancel</Button>
                    <Button variant='outlined' onClick={() => validate()} autoFocus >
                        Add
                    </Button>
                </div>
            </DialogActions>
        </Dialog>

    );
}